
export async function printEditorContent(title, editor) {
  const html = editor.getHTML()

  // Create a print-friendly window
  const printWindow = window.open('', '_blank', 'width=800,height=600')
  if (!printWindow) return

  // Build print HTML
  printWindow.document.write(`
    <!DOCTYPE html>
    <html>
    <head>
      <title>${title}</title>
      <style>
        body {
          font-family: system-ui, sans-serif;
          padding: 1in;
          color: #000;
        }
        h1, h2, h3 {
          font-weight: bold;
        }
        ul, ol {
          margin-left: 1.5em;
        }
        @media print {
          @page { margin: 20mm; }
        }
      </style>
    </head>
    <body>${html}</body>
    </html>
  `)

  // Wait for content to load
  await new Promise(r => setTimeout(r, 100))

  // Print and close
  printWindow.document.close()
  printWindow.focus()
  printWindow.print()
  printWindow.close()
}
